import Popover from "react-bootstrap/Popover";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import { Globe } from 'lucide-react'
import { TZDate } from '@date-fns/tz'
import { format } from 'date-fns'

interface TZDateTimeOverlayProps {
  timestamp: Date
  timezone?: string
  title: string
  timestampFormat?: string
}


export const TZDateTimeOverlay = ({ timestamp, timezone, title, timestampFormat }: TZDateTimeOverlayProps) => {
  let tzDate = ''
  if (timezone) {
    tzDate = format(new TZDate(timestamp, timezone), timestampFormat || 'dd/MM/yyyy HH:mm');
  } else {
    tzDate = format(new Date(timestamp), timestampFormat || 'dd/MM/yyyy HH:mm');
  }
  return (
    <OverlayTrigger
      delay={{ hide: 450, show: 300 }}
      trigger={['hover', 'focus']}
      overlay={
        <Popover
          id="popover-trigger-hover-focus"
          title="Date in Device Timezone"
        >
          <Popover.Header as="h6">{title}</Popover.Header>
          <Popover.Body>
            <strong>{timezone}</strong><br/>
            <strong>{tzDate}</strong><br/>
          </Popover.Body>
        </Popover>
      }
      placement="right-end"
    >
      <Globe size={15} className={'ml-1 text-info'}/>
    </OverlayTrigger>
  )
}

